import UploadImage from '@/components/upload-image/index.vue';
import ProcessNavigation from '@/components/process-navigation/index.vue';
import { errorMessage } from '@/utils/message.js';
import { mapGetters } from 'vuex';

import PublishPurchaseService from '../publish-purchase-service';
import Service from '@/service/index.js';

export default {
  components: {
    UploadImage,
    ProcessNavigation
  },
  data() {
    return {
      // processList: ['业务流程及准备材料', '编辑项目信息', '编辑意向供应人（投标人）资格要求', '上传附件信息', '确定承诺信息', '编辑采购文件', '提交申请'],
      step: 4,
      id: '',
      oldId: '',
      tradeType: '',
      isCreated: true,
      projectInfo: {},
      form: {
        files: []
      },
      purchaseFileType: [],
      projectTypeOfPur: null,
      purchaseType: null,
      action: '/api/v1.0/chanquan/fast/uploadFile',
      headers: {},
      fileList: [],
      fileList2: []
    };
  },
  computed: {
    ...mapGetters({
      userInfo: 'userInfo',
      processList: 'purchaseProcessList',
      getTenantParams: 'getTenantParams'
    })
  },
  created () {
    window.scrollTo(0, 0);
    const token = this.userInfo.accessToken;
    const tId = this.getTenantParams.tId; // 租户id,跟区域相关
    if (token) {
      this.headers['Authorization'] = token;
      this.headers['TENANT-ID'] = tId;
    }

    this.id = this.$route.query.id;
    this.oldId = this.$route.query.oldId;
    this.projectTypeOfPur = this.$route.query.projectTypeOfPur;
    this.purchaseType = Number(this.$route.query.purchaseType);
    Service.getSelectList('PURCHASE_FILE').then(res => {
      if (res && res.code === '0') {
        if(this.userInfo.type === 2) {
          this.purchaseFileType = res.data.sort((a, b) => a.sort - b.sort).splice(0, 6);
          // this.initFiles();
        } else {
          this.purchaseFileType = res.data.sort((a, b) => a.sort - b.sort).splice(1, 5);
          // this.initFiles();
        }
        if ([4, 5].includes(this.purchaseType)) {
          let tempList = res.data.filter(item => item.code === '17' || item.code === '18');
          this.purchaseFileType = [...this.purchaseFileType, ...tempList];
        }
        this.initFiles();
        console.log(res.data, this.purchaseFileType, '=====res');
      }
    });
  },
  methods: {
    initFiles () {
      this.purchaseFileType.forEach(item => {
        this.form.files.push({
          projectFileType: Number(item.code),
          title: item.value,
          filePaths: [],
          defaultImage: [],
          inputValue: null,
          description: item.description
        });
      });
      if (this.id) {
        this.getNewAttachmentInfo().then(() => {}, () => {
          if (this.oldId) {
            this.getOldAttachmentInfo();
          }
        });
      }
    },
    // 文件上传成功
    handleUpSuccess(response, file, fileList) {
      console.log(response, file, fileList);
      console.log(response,  file, fileList);
      let index = this.form.files.findIndex(item => item.projectFileType === 17);
      let fileInfo = {
        filePaths: [response.data.fullPath],
        projectFileType: 17,
        fileName: file.name
      };
      if(index >= 0) {
        this.form.files[index] = fileInfo;
      } else {
        this.form.files.push(fileInfo);
      }
    },
    handleUpRemove() {
      this.filedata = {};
      let index = this.form.files.findIndex(item => item.projectFileType === 17);
      // 清空已经上传的文件
      if (index >= 0) {
        this.form.files.splice(index, 1);
      }
    },
    // 文件上传成功
    handleUpSuccess2(response, file, fileList) {
      console.log(response, file, fileList);
      console.log(response,  file, fileList);
      let index = this.form.files.findIndex(item => item.projectFileType === 18);
      let fileInfo = {
        filePaths: [response.data.fullPath],
        projectFileType: 18,
        fileName: file.name
      };
      if(index >= 0) {
        this.form.files[index] = fileInfo;
      } else {
        this.form.files.push(fileInfo);
      }
    },
    handleUpRemove2() {
      this.filedata = {};
      let index = this.form.files.findIndex(item => item.projectFileType === 18);
      // 清空已经上传的文件
      if (index >= 0) {
        this.form.files.splice(index, 1);
      }
    },
    beforeUpload(file) {
      var testmsg=file.name.substring(file.name.lastIndexOf('.')+1);
      const extension = testmsg === 'xls';
      const extension2 = testmsg === 'xlsx';
      const extension3 = testmsg === 'doc';
      const extension4 = testmsg === 'docx';
      const extension5 = testmsg === 'pdf';
      const isLt2M = file.size / 1024 / 1024;
      console.log(file);
      if(!extension && !extension2 && !extension3 && !extension4 && !extension5) {
        this.$message({
          message: '上传文件只能是 doc、docx、pdf、xls、xlsx格式!',
          type: 'error',
          duration: 1000,
          offset: 327
        });
      }
      if(isLt2M > 50) {
        this.$message({
          message: '上传文件大小不能超过 50MB!',
          type: 'error',
          duration: 1000,
          offset: 327
        });
      }
      return (extension || extension2 || extension3 || extension4 || extension5) && isLt2M;
    },
    getNewAttachmentInfo () {
      console.log(1111);
      return new Promise((resolve, reject) => {
        PublishPurchaseService.getPurchaseInfo({
          purchaseId: this.id,
          echoCode: 'FILE'
        }).then(res => {
          if (!res.data) {
            reject();
          }
          this.isCreated = false;
          res.data && res.data.files.forEach(item => {
            const index = this.form.files.findIndex(file => {
              return Number(file.projectFileType) === Number(item.projectFileType);
            });
            if(index >= 0) {
              
              if (item.projectFileType === 17) {
                this.form.files[index] = {
                  ...item,
                  filePaths: [item.filePaths[0].fullPath]
                };
                this.fileList = [{name: item.fileName, url: item.filePaths[0].allPath}];
              } else if (item.projectFileType === 18) {
                this.form.files[index] = {
                  ...item,
                  filePaths: [item.filePaths[0].fullPath]
                };
                this.fileList2 = [{name: item.fileName, url: item.filePaths[0].allPath}];
              } else {
                item.filePaths.forEach(image => {
                  this.form.files[index].defaultImage.push({
                    url: image.allPath,
                    ossImgUrl: image.allPath,
                    sourceImgUrl: image.fullPath
                  });
                  this.form.files[index].filePaths.push({
                    ossImgUrl: image.allPath,
                    sourceImgUrl: image.fullPath
                  });
                  this.form.files[index].inputValue = this.form.files[index].filePaths.length;
                });
              }
            }
          });
          resolve();
        });
      });
    },
    getOldAttachmentInfo () {
      return new Promise((resolve, reject) => {
        PublishPurchaseService.getPurchaseInfo({
          purchaseId: this.oldId,
          echoCode: 'FILE'
        }).then(res => {
          if (!res.data) {
            reject();
          }
          this.isCreated = true;
          res.data && res.data.files.forEach(item => {
            const index = this.form.files.findIndex(file => file.projectFileType === item.projectFileType);
            if (index === -1) {return; }
            if (item.projectFileType === 17) {
              this.form.files[index] = {
                ...item,
                filePaths: [item.filePaths[0].fullPath]
              };
              this.fileList = [{name: item.fileName, url: item.filePaths[0].allPath}];
            } else if (item.projectFileType === 18) {
              this.form.files[index] = {
                ...item,
                filePaths: [item.filePaths[0].fullPath]
              };
              this.fileList2 = [{name: item.fileName, url: item.filePaths[0].allPath}];
            } else {
              item.filePaths.forEach(image => {
                this.form.files[index].defaultImage.push({
                  url: image.allPath,
                  ossImgUrl: image.allPath,
                  sourceImgUrl: image.fullPath
                });
                this.form.files[index].filePaths.push({
                  ossImgUrl: image.allPath,
                  sourceImgUrl: image.fullPath
                });
                this.form.files[index].inputValue = this.form.files[index].filePaths.length;
              });
            }
          });
          resolve();
        });
      });
    },
    fileRules (item) {
      let required = true;
      if (item.projectFileType === 6 || item.projectFileType === 7) {
        required = false;
      }
      return {
        required: required,
        message: '请上传' + item.title,
        trigger: 'change'
      };
    },
    uploadImage (index, event) {
      this.form.files[index].filePaths = event;
      if (event.length) {
        this.form.files[index].inputValue = event.length;
      } else {
        this.form.files[index].inputValue = null;
      }
    },
    previousStep () {
      this.$router.back();
    },
    next() {
      this.$refs['attachmentForm'].validate(valid => {
        if (valid) {
          const files = [];
          this.form.files.forEach(item => {
            console.log(item, '===item');
            if([17, 18].includes(item.projectFileType)) {
              files.push({
                imgEnumType: item.projectFileType,
                urls: item.filePaths,
                fileName: item.fileName
              });
            } else {
              const filePaths = [];
              item.filePaths.forEach(obj => {
                filePaths.push(obj.sourceImgUrl);
              });
              files.push({
                imgEnumType: item.projectFileType,
                urls: [...filePaths]
              });
            }
          });
          // 一般招标、依法必招
          if ([4, 5].includes(this.purchaseType)) {
            let result1 = files.find(item => item.imgEnumType === 17);
            console.log(result1, '=====result1');
            if (!(result1?.urls.length === 1)) {
              this.$errorMessage('请上传相关文件');
              return;
            }
            let result2 = files.find(item => item.imgEnumType === 18);
            if (!(result2.urls.length === 1))  {
              this.$errorMessage('请上传标书');
              return;
            }
          }
          if (this.isCreated) {
            this.saveAttachmentInfo(files);
          } else {
            this.updateAttachmentInfo(files);
          }
        } else {
          return false;
        }
      });
    },
    saveAttachmentInfo (files) {
      PublishPurchaseService.saveAttachmentInfo({
        purchaseId: this.id,
        files: files
      }).then(res => {
        if (res && res.code === '0') {
          if (this.oldId) {
            this.$router.push(`/publish-purchase/commitment-form?id=${this.id}&oldId=${this.oldId}&projectTypeOfPur=${this.projectTypeOfPur}`);
          } else {
            this.$router.push(`/publish-purchase/commitment-form?id=${this.id}&projectTypeOfPur=${this.projectTypeOfPur}`);
          }
        } else if (res && res.reason) {
          errorMessage(res && res.reason);
        } else {
          errorMessage('保存附件信息失败');
        }
      }, (error) => {
        if (error && error.data && error.data.reason) {
          errorMessage(error.data.reason);
        } else {
          errorMessage('保存附件信息失败');
        }
      });
    },
    updateAttachmentInfo (files) {
      PublishPurchaseService.updateAttachmentInfo({
        purchaseId: this.id,
        files: files
      }).then(res => {
        if (res && res.code === '0') {
          if (this.oldId) {
            this.$router.push(`/publish-purchase/commitment-form?id=${this.id}&oldId=${this.oldId}&projectTypeOfPur=${this.projectTypeOfPur}`);
          } else {
            this.$router.push(`/publish-purchase/commitment-form?id=${this.id}&projectTypeOfPur=${this.projectTypeOfPur}`);
          }
        } else if (res && res.reason) {
          errorMessage(res && res.reason);
        } else {
          errorMessage('更新附件信息失败');
        }
      }, (error) => {
        if (error && error.data && error.data.reason) {
          errorMessage(error.data.reason);
        } else {
          errorMessage('更新附件信息失败');
        }
      });
    }
  }
};
